module.exports = __webpack_public_path__ + "static/img/3.c5236ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/eng/3.png
// module id = A3YR
// module chunks = 0